import { addDays, startOfMonth, startOfWeek } from 'date-fns'
import { useMemo } from 'react'

interface UseCalendarDaysOptions {
    mode?: 'week' | 'month'
    calendarDate: Date
    firstDayOfWeek?: 0 | 1 | 2 | 3 | 4 | 5 | 6
    dayRowsCount?: number
}

export const useCalendarDays = ({ mode, calendarDate, firstDayOfWeek, dayRowsCount = 6 }: UseCalendarDaysOptions) => {
    return useMemo(() => {
        const firstDayOfCurrentMonth = startOfMonth(calendarDate)
        const firstDayOfCurrentWeek = startOfWeek(firstDayOfCurrentMonth, {
            weekStartsOn: firstDayOfWeek
        })

        const isWeekMode = mode === 'week'

        const days: Date[][] = []
        const rows = isWeekMode ? 1 : dayRowsCount
        for (let i = 0; i < rows; i++) {
            const cells: Date[] = []
            for (let j = 0; j < 7; j++) {
                cells.push(addDays(isWeekMode ? calendarDate : firstDayOfCurrentWeek, i * 7 + j))
            }
            days.push(cells)
        }

        return days
    }, [mode, calendarDate, dayRowsCount, firstDayOfWeek])
}
